import { useMemo } from 'react';
import { useTable, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import Filter from '../Filter/Filter';
import './table.css';
import DownloadExcelComponent from './downloadExcelComponent';


export default function Table({ idContent, columns, data, hideFilter, hideDownloadButton, hidePagination, pgSize, pgIndex, fileNameDownload, transposedSettings, trheadStyle, headerExport }) {
    columns = useMemo(() => columns, []);

    // Use the state and functions returned from useTable to build your UI
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        prepareRow,
        pageOptions,
        state,
        setGlobalFilter
    } = useTable({
        columns,
        data,
        initialState: {
            pageSize: pgSize ? pgSize : 20,
            pageIndex: pgIndex ? pgIndex : 0,
            hiddenColumns: columns.map(column => {
                if (column.show === false) return column.accessor || column.id;
            })
        }
    }, useGlobalFilter, useSortBy, usePagination);

    const { globalFilter, pageIndex } = state;

    if (trheadStyle == []) headerGroups.forEach(() => trheadStyle.push({}));

    if(headerExport) {
        data.map((item, index) => {
            if(item.administrador) {
                item['administradorName'] = item.administrador.name
                item['administradorEmail'] = item.administrador.email
            }
            if(item.operador) {
                item['operadorName'] = item.operador.name
                item['operadorEmail'] = item.operador.email
            }
        })

    }


    // Render the UI for your table
    return (
        <>
            <div className="d-flex justify-content-between pb-2">
                <div className="">
                    {
                        !hideFilter &&
                        <Filter filter={globalFilter} setFilter={setGlobalFilter}></Filter>
                    }
                </div>
                {
                    !hideDownloadButton &&
                    <div className="">
                        <DownloadExcelComponent data={data} columns={(headerExport) ? headerExport : columns} fileNameDownload={fileNameDownload} />
                    </div>
                }
            </div>
            <div className="table-responsive">
                <table {...getTableProps()} className="table table-rounded table-row-bordered border gy-7 gs-7  dataTable no-footer" id={idContent}>
                    <thead className="">
                        {headerGroups.map((headerGroup, indexTr) => (
                            <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200" style={trheadStyle[indexTr]} key={indexTr} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map((column, indexTh) => (
                                    <th  key={indexTh} {...column.getHeaderProps([
                                        {
                                            className: column.className ,
                                            style: column.style,
                                        },
                                    ])}
                                        {...column.getHeaderProps(column.getSortByToggleProps())}>
                                        {column.render('Header')}
                                        <span>
                                            {column.isSorted ?
                                                column.isSortedDesc ?
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-down" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" />
                                                        </svg>
                                                    </>
                                                    :
                                                    <>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-up" viewBox="0 0 16 16">
                                                            <path fillRule="evenodd" d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5z" />
                                                        </svg>
                                                    </>
                                                : ''}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="">
                        {page.map((row, indexRow) => {
                            prepareRow(row)
                            return (
                                <tr key={indexRow} className={transposedSettings?.rowsClasses ? transposedSettings.rowsClasses[indexRow] : ""}>
                                    {
                                        row.cells.map((cell, indexCell) => {
                                            if (transposedSettings?.firstColumn && indexCell == 0) { //first column
                                                if (transposedSettings?.rowsSpan[indexRow] > 0) {  /*is a transposed table header with rowspan*/
                                                    return (
                                                        <td key={indexRow}
                                                            style={{ verticalAlign: "middle", textAlign: "left" }}
                                                            {...transposedSettings.rowsSpan[indexRow] ? { rowSpan: transposedSettings.rowsSpan[indexRow] } : {}}
                                                            className="fw-bolder text-center min-w-50px text-blue bg-light-blue"
                                                        >
                                                            {transposedSettings?.firstColumn[indexRow]}
                                                        </td>
                                                    )
                                                } else { //rowspan: empty cell
                                                    return
                                                }
                                            }

                                            return (
                                                <td key={indexCell}
                                                    {...cell.getCellProps([
                                                        {
                                                            className: cell.column.className,
                                                            style: cell.column.style,
                                                        }
                                                    ])}
                                                >
                                                    {cell.render('Cell')}
                                                </td>
                                            )
                                        })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            {
                !hidePagination &&
                <>
                    <button
                        onClick={() => previousPage()}
                        className="btn btn-link btn-color-gray-500  me-5 mb-2 btn-white"
                        disabled={!canPreviousPage}
                    ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left-short" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z" />
                        </svg></button>
                    <span className="me-5 text-primary">
                        Paginas
                        <strong>
                            {' ' + (~~pageIndex + 1).toString()} al {pageOptions.length + ' '}
                        </strong>
                    </span>
                    <button
                        onClick={() => nextPage()}
                        disabled={!canNextPage} className="btn btn-link btn-color-gray-500  me-5 mb-2 btn-white"
                    ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-right-short" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z" />
                        </svg></button>
                </>
            }
        </>
    )
}